import MJSONScreenshot from '@admin/components/mjson_screenshot'
import LibraryToken from '@apps/truevail/admin/tokens/library'
import PropTypes from 'prop-types'
import React from 'react'

const getScreenshot = (email_campaign) => ({
  engine: 'mjson',
  entity: `truevail_email_campaign_variants/${email_campaign.variants[0].code}`,
  width: 100,
  height: 75,
  screenshoted_at: email_campaign.variants[0].screenshoted_at
})

const EmailCampaignCard = ({ email_campaign }) => (
  <div className="maha-card-layout-card-body">
    <div className="maha-card-layout-card-screenshot">
      <MJSONScreenshot { ...getScreenshot(email_campaign) } />
    </div>
    <div className="maha-card-layout-card-details">
      <div className="token-stats">
        { email_campaign.variants_count } variants, { email_campaign.publishings_count } publishings<br />
        <LibraryToken value={ email_campaign.library_status } />
      </div>
    </div>
  </div>
)

EmailCampaignCard.propTypes = {
  email_campaign: PropTypes.object
}

export default EmailCampaignCard
